import { GA_ID } from '../constants/Config';

// Small guard so we don't call gtag before it's loaded
function hasGtag() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

/**
 * Track a page view (manual for SPAs)
 * @param url - the page path or full URL
 * @param title - optional page title
 */
export function trackPageView(url, title) {
  if (!GA_ID || !hasGtag()) return;

  window.gtag('event', 'page_view', {
    page_location: window.location.href,
    page_path: url,
    page_title: title || document.title,
  });
}

function sanitizeParams(params) {
  const out = {};
  if (!params) return out;
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === '') continue;
    out[k] = k === 'value' && typeof v === 'string' && !Number.isNaN(Number(v)) ? Number(v) : v;
  }
  return out;
}

/**
 * Track a custom GA4 event
 * @param eventName - the event name (e.g. "profile_update")
 * @param params - event parameters (must be primitives)
 */
export function trackEvent(eventName, params) {
  if (!GA_ID || !hasGtag()) return;

  window.gtag('event', eventName, sanitizeParams(params));
}

/**
 * Set user properties once per session
 * @param props - user properties object (e.g. { user_id: "123", plan: "pro" })
 */
let userPropsSet = false;
export function setUserProperties(props) {
  if (!GA_ID || !hasGtag() || userPropsSet) return;

  window.gtag('set', 'user_properties', props);
  if (props.user_id) {
    window.gtag('set', { user_id: props.user_id });
  }
  userPropsSet = true;
}
